import { prefix } from '../../utils/prefix';

const Url = {
  getInfo: `${prefix}/info/basicInfo/get`,
  getPinYinXing: `${prefix}/dataset/pinYinXing`,
  getPinYinMing: `${prefix}/dataset/pinYinMing`,
  save: `${prefix}/info/basicInfo/save`,
  upload: `${prefix}/attachment/upload`, // 上传证件照
  workCardUpload: `${prefix}/attachment/workCardUpload`, // ai识别工卡照
};

export default Url;
